import React from 'react'

import RdnaText from '@ringdna/common/src/components/RdnaText'

const BlockHeader = ({ title }: { title: string }) => {
  return <RdnaText variant="h4">{title}</RdnaText>
}

export default BlockHeader
